<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Accounts </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Opening Balance Entry</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-dark float-right" @click="redirectRoute('/accounting/voucher-list')">
                              <i class="mdi mdi-arrow-left-thin"></i> Back
                            </button>  -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <form @submit.prevent="submitOpeningBalanceForm()" enctype="multipart/form-data" id="ventry_form" class="ventry_form" v-if="!loading">
                                    <div class="col-md-12">
                                        <div class="row">
                                            
                                            <div class="form-group col-md-3">
                                                <label for="company_id">Company *</label><br>
                                                <Multiselect 
                                                    class="form-control border company_id" 
                                                    mode="single"
                                                    v-model="vform.company_id"
                                                    placeholder="Company Select"  
                                                    :searchable="true" 
                                                    :filter-results="true"
                                                    :options="company_options"
                                                    :classes="multiclasses"
                                                    :close-on-select="true" 
                                                    :min-chars="1"
                                                    :resolve-on-load="false"
                                                    @change="getOpeningBalanceLedger($event, 'company'), getFiscalYear($event)"
                                                /> 
                                                <div class="invalid-feedback" v-if="errors.company_id">
                                                    {{errors.company_id[0]}}
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="fiscalyear_id">Fiscal Year *</label>
                                                    <!-- <select class="form-control border" v-model="vform.fiscalyear_id" @change="getOpeningBalanceLedger($event.trget.value, 'fiscal_year'), onkeyPress('fiscalyear_id')">
                                                        <option v-for="(fiscal_year, f) in company_fiscal_years" :key="f" :value="fiscal_year.id">{{ fiscal_year.start_date+' to '+fiscal_year.end_date }}</option>
                                                    </select> -->

                                                    <select class="form-control border" v-model="vform.fiscalyear_id" @change="getOpeningBalanceLedger($event.trget.value, 'fiscal_year'), onkeyPress('fiscalyear_id')">
                                                        <option :key="fiscal_year.id" :value="fiscal_year.id">{{ fiscal_year.start_date+' to '+fiscal_year.end_date }}</option>
                                                        <!-- <template v-if="fiscal_years.length > 0">
                                                            <option v-for="(fiscal_year, f) in fiscal_years" :key="f" :value="fiscal_year.id">{{ fiscal_year.start_date+' to '+fiscal_year.end_date }}</option>
                                                        </template> -->
                                                    </select>
                                                    <div class="invalid-feedback" v-if="errors.fiscal_year_id">
                                                        {{ errors.fiscal_year_id }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="mb-3">
                                                    <label for="vnumber">Date *</label>
                                                    <input type="date" :min="active_min_date" :max="active_max_date" class="form-control border" v-model="vform.vdate" @keypress="onkeyPress('vdate')" />
                                                    <div class="invalid-feedback" v-if="errors.vdate">
                                                        {{ errors.vdate }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group col-md-3">
                                                <label for="import_file">Import File (xlsx, csv, xls)</label>
                                                <input
                                                    type="file"
                                                    class="form-control border"
                                                    id="import_file"
                                                    accept=".xlsx,.csv,.xls"
                                                    @change="handleFileUpload"
                                                />
                                                <div class="invalid-feedback" v-if="errors.import_file">
                                                    {{ errors.import_file[0] }}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                        
                                    <hr>

                                    <div class="entry_table" style="position: relative;" v-if="vform.import_file == null || vform.import_file == ''">
                                        <div v-if="!ledgerLoading">
                                            <table class="table table-bordered w-100">
                                                <thead class="table-light">
                                                    <tr class="border success item-head">
                                                        <th class="text-center">Assets</th> 
                                                        <th class="text-center">Liabilities</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <table class="table w-100" style="margin-bottom: 10px;">
                                                                <tr>
                                                                    <th width="40%">Particular</th>
                                                                    <th width="40%">Cost Center</th>
                                                                    <th style="text-align: right;">Amount</th>
                                                                </tr>
                                                                <template v-if="vform.accounts[0].assets.length > 0">
                                                                    <tr v-for="(item, index) in vform.accounts[0].assets" :key="index">
                                                                        <td width="40%">{{ item.ledger_name }}</td>
                                                                        <td width="40%">
                                                                            <treeselect 
                                                                                v-model="item.cost_center_id"
                                                                                :multiple="false" 
                                                                                :always-open="false"
                                                                                :options="costWithProfitCenterOptions"
                                                                                :value-consists-of="valueConsistsOf"
                                                                                :normalizer="normalizerCostCenter"
                                                                                :default-expand-level="Infinity"
                                                                                :disable-branch-nodes="true"
                                                                                :search-nested="true"                                                
                                                                                placeholder='Select Cost Center'
                                                                                v-if="renderOptionComponent"
                                                                            />
                                                                        </td>
                                                                        <td><input type="number" step="any" class="form-control" style="text-align: right;" v-model="item.debit"></td>
                                                                    </tr>
                                                                </template>
                                                            </table>
                                                        </td>
                                                        <td>
                                                            <table class="table w-100" style="margin-bottom: 10px;">
                                                                <tr>
                                                                    <th width="40%">Particular</th>
                                                                    <th width="40%">Cost Center</th>
                                                                    <th style="text-align: right;">Amount</th>
                                                                </tr>
                                                                <template v-if="vform.accounts[0].liabilities.length > 0">
                                                                    <tr v-for="(item, index) in vform.accounts[0].liabilities" :key="index">
                                                                        <td width="40%">{{ item.ledger_name }}</td>
                                                                        <td width="40%">
                                                                            <treeselect 
                                                                                v-model="item.cost_center_id"
                                                                                :multiple="false" 
                                                                                :always-open="false"
                                                                                :options="costWithProfitCenterOptions"
                                                                                :value-consists-of="valueConsistsOf"
                                                                                :normalizer="normalizerCostCenter"
                                                                                :default-expand-level="Infinity"
                                                                                :disable-branch-nodes="true"
                                                                                :search-nested="true"                                                
                                                                                placeholder='Select Cost Center'
                                                                                v-if="renderOptionComponent"
                                                                            />
                                                                        </td>
                                                                        <td><input type="number" step="any" class="form-control" style="text-align: right;" v-model="item.credit"></td>
                                                                    </tr>
                                                                </template>
                                                            </table>
                                                        </td>
                                                    </tr>

                                                    <!-- For Total Amount -->
                                                    <tr>
                                                        <td>
                                                            <table class="table w-100" style="margin-bottom: 10px;">
                                                                <tr>
                                                                    <th colspan="2" width="50%">Total</th>
                                                                    <th style="text-align: right;">{{ totalDebitAmount }}</th>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                        <td>
                                                            <table class="table w-100" style="margin-bottom: 10px;">
                                                                <tr>
                                                                    <th colspan="2" width="50%">Total</th>
                                                                    <th style="text-align: right;">{{ totalCreditAmount }}</th>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="tab-pane show active" v-if="ledgerLoading">
                                            <div class="row"> 
                                                <div class="col-md-5">  
                                                </div>
                                                <div class=" col-md-2"> 
                                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                                </div>
                                                <div class="col-md-5">  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    

                                    <div class="col-md-12">
                                        <div class="mb-3">
                                            <label for="global_note"> Note *</label>
                                            <textarea class="form-control border" rows="3" v-model="vform.global_note" @keypress="onkeyPress('global_note')"></textarea>
                                            <div class="invalid-feedback" v-if="errors.global_note">
                                                {{errors.global_note[0]}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <button type="submit" class="btn btn-primary float-right" :disabled="disabled"> 
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>
                                            <i class="mdi mdi-content-save-all"></i> Save
                                        </button>
                                        <button type="button" class="btn btn-danger float-right" style="margin-right: 5px;"> <i class="mdi mdi-close"></i> Cancel</button>
                                    </div>
                                </form>                        
                            </div>
                        </div>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row"> 
                                <div class="col-md-5">  
                                </div>
                                <div class=" col-md-2"> 
                                    <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                </div>
                                <div class="col-md-5">  
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>     
            
        </div>
    </transition>
</template>
<script>
import Modal from "./../helper/Modal";
import { ref, onMounted } from "vue";
import axios from 'axios';
import Form from 'vform';
import NumberToWord from './../page/NumberToWord.vue';   

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        NumberToWord
    },
    data() {
        return {
            loading: true,
            ledgerLoading: false,
            isSubmit: false,
            disabled: false,
            showModal: false,
            modalActive:false,
            errors: {},
            vitem: '',
            entry_types: [],
            vtype_value: 'opening_balance',
            vtype_id: 0,
            companies: [],
            company_options: [],
            fiscal_year: '',
            fiscal_years: [],
            company_fiscal_years: [],
            active_min_date: '',
            active_max_date: '',
            cost_centers: [],
            costCenterOptions: [],
            costWithProfitCenterOptions: [],
            ledgers: [],
            ledger_options: [],
            ledger_id: null,
            renderOptionComponent: true,
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id +'___'+node.code,
                    label: '['+ node.code +'] '+ node.name,
                    // isDisabled: disable_item,
                    children: node.children,
                    // children_data
                }
            },

            normalizerCostCenter(node) {
                return {
                    id: node.id +'___'+node.code,
                    label: node.name,
                    children: node.children,
                }
            },
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
            vform: new Form({
                company_id: '',
                profit_center_id: '',
                vdate: new Date().toISOString().slice(0,10),
                fiscalyear_id: '',
                global_note: '',
                accounts: [
                    {
                        'assets': [],
                        'liabilities': [],
                    }
                ],
                import_file: null,
                
            }),
        };
    },
    created() {
        this.fetchCompany();
        this.fetchCostCenters();
        this.fetchActiveFiscalYear();
        this.fetchFiscalYears();
    },
    methods: {
        redirectRoute: function(route_link) {
            this.$router.push(route_link);
        },

        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data;
                // this.company_options = [{label: "Select Company", value: ""}];
                res.data.data.map((item) => {
                    this.company_options.push({label: item.name, value: item.id});
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            })
            .finally(() => {
                this.loading = false;
            });
        },

        // Cost Center Data
        fetchCostCenters()
        {
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((res) => {
                this.cost_centers = res.data.data.cost_centers;
                this.costCenterOptions = res.data.data.cost_center_options;
                this.costWithProfitCenterOptions = res.data.data.cost_and_profit_center_options;
            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            });
        },

        // Fetch Active Fiscal Year
        fetchActiveFiscalYear(company_id='') {
            var data = {company_id: company_id}
            axios.post(this.apiUrl+'/fiscal_years/getActiveFiscalYear', data, this.headerjson) 
            .then((resp) => {
                this.fiscal_year = resp.data.data;
                this.vform.fiscalyear_id = this.fiscal_year.id;
                this.vform.vdate = this.fiscal_year.start_date;
                this.active_min_date = this.fiscal_year.start_date;
                this.active_max_date = this.fiscal_year.end_date;
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },

        fetchFiscalYears() {
            axios.get(this.apiUrl+'/fiscal_years', this.headerjson) 
            .then((resp) => {
                this.fiscal_years = resp.data.data;
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },

        getFiscalYear: function(value) {
            // let selectVal = value;
            // this.vform.company_id = selectVal;
            // if(this.vform.company_id == '' || this.vform.company_id == null) {
            //     return false;
            // }else {
            //     this.company_fiscal_years = this.fiscal_years.filter((item) => item.company_id == this.vform.company_id);
            //     let active_fiscal_year = this.company_fiscal_years.filter((item) => item.status == 1);
            //     if(active_fiscal_year.length > 0) {
            //         this.vform.fiscalyear_id = active_fiscal_year[0].id;
            //         this.vform.vdate = active_fiscal_year[0].start_date;
            //         this.active_min_date = active_fiscal_year[0].start_date;
            //         this.active_max_date = active_fiscal_year[0].end_date;
            //     }else{
                    
            //         this.vform.fiscalyear_id = '';
            //         this.vform.vdate = '';
            //         this.active_min_date = '';
            //         this.active_max_date = '';
            //     }
            // }
        },

        getOpeningBalanceLedger: function(value, type) {
            let selectVal = value;
            if(type == "company") this.vform.company_id = selectVal; 
            if(type == "fiscal_year") this.vform.fiscalyear_id = selectVal;

            if(this.vform.company_id == '' || this.vform.company_id == null || this.vform.fiscalyear_id == '') {
                return false;
            }else {
                let filters = new Form({
                    company_id: this.vform.company_id,
                    profit_center_id: this.vform.profit_center_id,
                    fiscalyear_id: this.vform.fiscalyear_id,
                });

                this.fetchOpeningBalanceAccountData(filters);
            }
        },

        fetchOpeningBalanceAccountData(filters = null) {
            this.ledgerLoading = true;
            let postEvent = axios.post(this.apiUrl+'/accounts/opening-balance-ledger', filters, this.headerjson);
            postEvent.then((resp) => {
                console.log("fetchOpeningBalanceAccountData==", resp.data.data);
                this.vform.accounts[0].assets = resp.data.data.assets_ledgers;  
                this.vform.accounts[0].liabilities = resp.data.data.liabilities_ledgers;  
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message)
            })
            .finally(() => {
                this.ledgerLoading = false;
            });
        },


        handleFileUpload(event) {
            this.vform.import_file = event.target.files[0];
            this.onkeyPress('import_file');
        },

        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        }, 

        // inputChange: function(block_index, index) {
        //     var debit_amount = this.vform.transaction_blocks[block_index].account_items.reduce(function(total, item){
        //         var debit_amount = (item.debit != '') ? item.debit : 0;
        //         return parseFloat(total + parseFloat(debit_amount)); 
        //     },0);

        //     var credit_amount = this.vform.transaction_blocks[block_index].account_items.reduce(function(total, item){
        //         var credit_amount = (item.credit != '') ? item.credit : 0;
        //         return parseFloat(total + parseFloat(credit_amount)); 
        //     },0);

        //     this.vform.transaction_blocks[block_index].total_debit_amount = debit_amount;
        //     this.vform.transaction_blocks[block_index].total_credit_amount = credit_amount;
        // },

        submitOpeningBalanceForm: function(event) {
            this.isSubmit = true; 
            this.disabled = true;

            if((this.totalDebitAmount == this.totalCreditAmount) && (this.totalDebitAmount != 0 && this.totalCreditAmount != 0)) {
                var formData = new FormData();
                formData.append("company_id", this.vform.company_id);
                formData.append("profit_center_id", this.vform.profit_center_id);
                formData.append("fiscal_year_id", this.vform.fiscalyear_id);
                formData.append("vdate", this.vform.vdate);
                formData.append("vtype_value", this.vtype_value);
                formData.append("global_note", this.vform.global_note);
                if(this.vform.import_file != null) {
                    formData.append("import_file", this.vform.import_file);
                }
                formData.append("accounts", JSON.stringify(this.vform.accounts));

                axios.post(this.apiUrl+'/accounts/opening-balance-store', formData, this.headers)
                .then((resp) => {
                    this.isSubmit = false;
                    this.disabled = false;
                    if(resp.status == 200){
                        console.log("datatdatata==", resp.data.data );
                        this.$toast.success(resp.data.message); 
                        setTimeout(() => {
                            window.location.reload(true);
                        }, 3000);
                    }else{
                        this.$toast.error(resp.data.message);
                    }
                })
                .catch((err) => {
                    this.isSubmit = false; 
                    this.disabled = false;
                    this.$toast.error(err.response.data.message);
                    if(err.response.status == 422){
                        this.errors = err.response.data.errors 
                    }
                })
            }else{
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error("Assets and Liabilities account total balance must be equal");
            }
        },

        // For Print
        printContent(document_id) {
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [
                    // 'https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css',
                    '/assets/css/app.min.css',
                    this.baseUrlPrintCSS+'/assets/css/bootstrap.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },

    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {

        totalDebitAmount: function(){ 
            return this.vform.accounts[0].assets.reduce(function(total, item){
                var debit_amount = (item.debit != '') ? item.debit : 0;
                return parseFloat(total + parseFloat(debit_amount)); 
            },0);
        }, 
        totalCreditAmount: function() {
            return this.vform.accounts[0].liabilities.reduce(function(total, item) {
                var credit_amount = (item.credit != '') ? item.credit : 0;
                return parseFloat(total + parseFloat(credit_amount)); 
            },0);
        },
    }
}
</script>
<style scoped>

.vue-treeselect__menu {
    z-index: 9999;
    display: none;
}
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 90%;
    display: block;
    margin: 0 auto;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}
</style>